import { useMemo } from "react";

import type { InterludeTypes } from "@/interlude";
import { interlude } from "@/interlude";

export const useMaacFeatureSettings = (): {
  isMaacFeatureSettingsValid: boolean;
  maacFeatureSettings: InterludeTypes["MaacFeatureSettings"] | undefined;
} => {
  const organizationSettingQuery =
    interlude.organization.useOrganizationSetting();

  const maacFeatureSettings = useMemo(() => {
    return organizationSettingQuery.data?.maacFeatureSettings;
  }, [organizationSettingQuery.data]);

  const isMaacFeatureSettingsValid = useMemo(
    () =>
      organizationSettingQuery.isFetched &&
      organizationSettingQuery.data !== undefined &&
      organizationSettingQuery.data?.maacFeatureSettings !== undefined,
    [organizationSettingQuery.data, organizationSettingQuery.isFetched],
  );

  return {
    isMaacFeatureSettingsValid,
    maacFeatureSettings,
  };
};
